var CoreModule = (function () {
    function CoreModule() {
    }
    return CoreModule;
}());
export { CoreModule };



// WEBPACK FOOTER //
// /opt/app/src/app/core/core.module.ts.pre-build-optimizer.js